import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SocialProof from "./components/SocialProof";
import Challenges from "./components/Challenges";
import Solutions from "./components/Solutions";
import InAction from "./components/InAction";
import Process from "./components/Process";
import Transformation from "./components/Transformation";
import CaseStudy from "./components/CaseStudy";
import MeasurableResults from "./components/MeasurableResults";
import WhyChooseUs from "./components/WhyChooseUs";
import Results from "./components/Results";
import Services from "./components/Services";
import ProvenIndustries from "./components/ProvenIndustries";
import SignatureProgram from "./components/SignatureProgram";
import AISection from "./components/AISection";
import Audiences from "./components/Audiences";
import Testimonials from "./components/Testimonials";
import AfterYouBook from "./components/AfterYouBook";
import Consultation from "./components/Consultation";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminForgotPassword from "./pages/AdminForgotPassword";
import AdminResetPassword from "./pages/AdminResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import Assessment from "./pages/Assessment";
import AssessmentLanding from "./pages/AssessmentLanding";
import WorkshopsTraining from "./pages/WorkshopsTraining";
import CaseStudiesIndex from "./pages/CaseStudiesIndex";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import FindYourBird from "./pages/FindYourBird";
import Events from "./pages/Events";
import UpcomingEvents from "./components/UpcomingEvents";
import { PartnerStrip } from "./components/PartnerStrip";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <Challenges />
        <Solutions />
        <InAction />
        <Process />
        <Transformation />
        <CaseStudy />
        <PartnerStrip heading="Trusted by Organizations Across Nevada" subheading="Real engagements with school districts, federal agencies, universities, chambers, and workforce partners." />
        <UpcomingEvents />
        <MeasurableResults />
        <WhyChooseUs />
        <Results />
        <Services />
        <ProvenIndustries />
        <SignatureProgram />
        <AISection />
        <Audiences />
        <Testimonials />
        <AfterYouBook />
        <Consultation />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/assessment" element={<AssessmentLanding />} />
          <Route path="/assessment/start" element={<Assessment />} />
          <Route path="/workshops" element={<WorkshopsTraining />} />
          <Route path="/case-studies" element={<CaseStudiesIndex />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/find-your-bird" element={<FindYourBird />} />
          <Route path="/disc-bird-quiz" element={<FindYourBird />} />
          <Route path="/events" element={<Events />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
